import React, { useState, useEffect } from "react";
import BaseController from "controllers/BaseController";
import { LoginView } from "views/auth/Login";

import Authentication from "api/Authentication";
import UserModel from "models/User";

import { LOGIN_SUCCESS, MESSAGE_ERROR } from "../../actions/types";
import { connect } from "react-redux";
import messageSlice from "redux/messageSlice";

class Login extends BaseController {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, validation: false };
    this.dispatch = this.props.dispatch;
  }

  componentDidMount() {
    console.log("LOGIN VIEW");
    //		const { dispatch, history } = this.props;
    //dispatch({ type: LOGIN_SUCCESS, payload: {} });
  }
  onSaveHandler = async (data) => {
    let isLoggedIn = await Authentication.loginUser(data);
    if (!isLoggedIn || isLoggedIn.status != 200) {
      this.dispatch({
        type: MESSAGE_ERROR,
        message: "E-mailadres en/of wachtwoord onjuist. Probeer het opnieuw.",
        header: "Ongeldige login",
      });
    } else if (isLoggedIn.status == 200) {
      const { user, companies, token } = isLoggedIn.data.data;
      this.dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: user, companies: companies, token: token },
      });
      this.dispatch(
        messageSlice.actions.submitMessage({
          action: LOGIN_SUCCESS,
          payload: { user: user, companies: companies, token: token },
        })
      );

      // Call the jQuery function to update WordPress components
      if (window.jQuery && window.jQuery.changeAuthState) {
        window.jQuery.changeAuthState("LOGIN_SUCCESS", user);
      } else {
        // Fallback to full page reload if necessary
        window.location.reload();
      }
    }
  };

  render() {
    return <LoginView onSave={this.onSaveHandler} />;
  }
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(Login);
/*
export default function Dashboard() {
	const api = new BaseAPI();  

api
      .getCategory()
      .then((response) => console.log(response))
      .catch((err) => console.log(err));
      
  return(
<Table striped bordered hover>
  <thead>
    <tr>
      <th>#</th>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Username</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Mark</td>
      <td>Otto</td>
      <td>@mdo</td>
    </tr>
    <tr>
      <td>2</td>
      <td>Jacob</td>
      <td>Thornton</td>
      <td>@fat</td>
    </tr>
    <tr>
      <td>3</td>
      <td colSpan="2">Larry the Bird</td>
      <td>@twitter</td>
    </tr>
  </tbody>
</Table>    
  );
}
*/
